var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { TvShopStateService } from '../../../services/state/tv-shop-state.service';
import { Order } from '../../../model/order';
import { OrderingModalManagerComponent } from '../../../modals/ordering-modals/ordering-modal-manager/ordering-modal-manager.component';
import { NavigableComponent } from '../../../model/navigable-component';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { PageNames } from '../../../shared/page-names.enum';
import { AnalyticsService } from '../../../services/analytics/analytics.service';
import { Router } from '@angular/router';
import { ImageUtils } from '../../../shared/utils/image/image-utils';
import { ProductTypeRenditionEnum } from '../../../constants/renditions/product-type-rendition.constants';
var StreamingBundleOptionsComponent = /** @class */ (function (_super) {
    __extends(StreamingBundleOptionsComponent, _super);
    function StreamingBundleOptionsComponent(navigationService, changeDetector, analyticsService, stateService, router) {
        var _this = _super.call(this, navigationService) || this;
        _this.navigationService = navigationService;
        _this.changeDetector = changeDetector;
        _this.analyticsService = analyticsService;
        _this.stateService = stateService;
        _this.router = router;
        _this.hasOptionSelected = false;
        _this.componentName = PageNames.STREAMING_BUNDLE_OPTION;
        _this.rendition = ProductTypeRenditionEnum.streamingBundle;
        _this.selectedTvShopEntertainmentPack = stateService.selectSnapshot(function (state) { return state.basket.selectedTvShopEntertainmentPack; });
        _this.checkIfAlreadySubscribed();
        _this.availableStreamingBundleOption = _this.selectedTvShopEntertainmentPack.streamingOption[0];
        _this.omapiId = _this.selectedTvShopEntertainmentPack.omapiId;
        var streamingBundleBasket = _this.stateService.selectSnapshot(function (state) { return state.basket; });
        _this.order = new Order(streamingBundleBasket.selectedTvShopEntertainmentPack.omapiId, streamingBundleBasket.selectedTvShopEntertainmentPack.priceDetail.price.value, null, null);
        return _this;
    }
    StreamingBundleOptionsComponent.prototype.ngOnInit = function () {
        this.navigationService.setCurrentPageComponent(PageNames.STREAMING_BUNDLE_OPTION);
        this.analyticsService.onDetailPage([this.selectedTvShopEntertainmentPack.omapiId]);
    };
    StreamingBundleOptionsComponent.prototype.ngAfterViewInit = function () {
        this.changeDetector.detectChanges();
        this.navigationService.registerPageElement(this.streamingbundleoption);
        this.navigationService.resetNavigation();
    };
    Object.defineProperty(StreamingBundleOptionsComponent.prototype, "backgroundImageUrl", {
        get: function () {
            return ImageUtils.getBackgroundImageUrl(this.selectedTvShopEntertainmentPack.omapiId, 'intro');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StreamingBundleOptionsComponent.prototype, "getLogoUrl", {
        get: function () {
            return ImageUtils.getLogoUrlForOmapiId(this.omapiId);
        },
        enumerable: true,
        configurable: true
    });
    StreamingBundleOptionsComponent.prototype.ngOnDestroy = function () {
        this.navigationService.clearNavigation();
    };
    StreamingBundleOptionsComponent.prototype.checkIfAlreadySubscribed = function () {
        if (this.selectedTvShopEntertainmentPack.subscribed) {
            this.onBack();
        }
    };
    StreamingBundleOptionsComponent.prototype.onEmitOrderProduct = function () {
        this.orderingModal.openModal();
    };
    StreamingBundleOptionsComponent.prototype.onBack = function () {
        this.navigationService.resetNavigation();
        this.navigationService.clearNavigation();
        this.routeOnBackPressed();
    };
    StreamingBundleOptionsComponent.prototype.onToggleStreamingOption = function (streamingServiceOptionId) {
        var selectedStreamingServiceOption = this.stateService.selectSnapshot(function (state) { return state.basket.selectStreamingServiceOption; });
        if (selectedStreamingServiceOption && (selectedStreamingServiceOption.omapiid === streamingServiceOptionId)) {
            this.hasOptionSelected = false;
            this.stateService.setSelectedStreamingBundleOption(undefined);
        }
        else {
            this.hasOptionSelected = true;
            this.stateService.setSelectedStreamingBundleOption(this.availableStreamingBundleOption);
        }
    };
    StreamingBundleOptionsComponent.prototype.routeOnBackPressed = function () {
        this.router.navigate(['/product-details/' + this.omapiId], { queryParamsHandling: 'merge' });
    };
    return StreamingBundleOptionsComponent;
}(NavigableComponent));
export { StreamingBundleOptionsComponent };
